import {
  VuexModule,
  Module,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";

import store from "@/store";
import Service from "@/services/CatatanHarianBblService";
import {
  CatatanHarianBblInterface,
  CatatanHarianBblListItem,
  BblAlertItem
} from "@/types/catatan_harian_bbl";

@Module({
  dynamic: true,
  namespaced: true,
  store,
  name: "catatan-harian-bbl"
})
class CatatanHarianBblStore extends VuexModule {
  loading = false;
  catatanList: CatatanHarianBblListItem[] = [];
  currentCatatan: CatatanHarianBblInterface | null = null;
  alerts: BblAlertItem[] = [];

  @Mutation
  SET_LIST(val: CatatanHarianBblListItem[]) {
    this.catatanList = val;
  }

  @Mutation
  SET_CURRENT(val: CatatanHarianBblInterface | null) {
    this.currentCatatan = val;
    // Extract alerts
    if (val && val.alerts) {
      this.alerts = val.alerts;
    } else {
      this.alerts = [];
    }
  }

  @Mutation
  SET_LOADING(val: boolean) {
    this.loading = val;
  }

  @Mutation
  RESET_STORE() {
    this.catatanList = [];
    this.currentCatatan = null;
    this.alerts = [];
    this.loading = false;
  }

  @Action({ rawError: true })
  async fetchByRegister(registerId: string | number): Promise<void> {
    this.SET_LOADING(true);
    const response = await Service.getByRegister(registerId).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_LIST(response.data?.data || []);
  }

  @Action({ rawError: true })
  async fetchByDate(params: { registerId: string | number; tanggal: string }): Promise<void> {
    this.SET_LOADING(true);
    const response = await Service.getByDate(params.registerId, params.tanggal).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_CURRENT(response.data?.data || null);
  }

  @Action({ rawError: true })
  async fetchById(id: number): Promise<void> {
    this.SET_LOADING(true);
    const response = await Service.find(id).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_CURRENT(response.data?.data || null);
  }

  @Action({ rawError: true })
  async createCatatan(data): Promise<any> {
    this.SET_LOADING(true);
    const response = await Service.create(data).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_CURRENT(response.data?.data || null);
    return response;
  }

  @Action({ rawError: true })
  async updateCatatan(params: { id: number; data: any }): Promise<any> {
    this.SET_LOADING(true);
    const response = await Service.update(params.id, params.data).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_CURRENT(response.data?.data || null);
    return response;
  }

  @Action({ rawError: true })
  async deleteCatatan(id: number): Promise<void> {
    this.SET_LOADING(true);
    await Service.destroy(id).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_CURRENT(null);
  }

  @Action({ rawError: true })
  async carryForward(params: { registerId: string | number; data: any }): Promise<any> {
    this.SET_LOADING(true);
    const response = await Service.carryForward(params.registerId, params.data).finally(() => {
      this.SET_LOADING(false);
    });
    this.SET_CURRENT(response.data?.data || null);
    return response;
  }

  @Action({ rawError: true })
  async verifyDpjp(id: number): Promise<any> {
    const response = await Service.verifyDpjp(id);
    this.SET_CURRENT(response.data?.data || null);
    return response;
  }

  @Action({ rawError: true })
  reset(): void {
    this.RESET_STORE();
  }
}

export default getModule(CatatanHarianBblStore);
